import { useEffect, useState } from 'react';
import {
  GridActionsCellItem,
  DataGridPro as DataGrid,
} from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as service from '../../../services/deere-service';
import ConfirmationDialog from '../../../components/ConfirmationDialog/ConfirmationDialog';

export function Tokens() {
  const [user, setUser] = useState();
  const [tokenToDelete, setTokenToDelete] = useState();
  const [tokens, setTokens] = useState();

  useEffect(() => {
    service.getAccessTokens().then(setTokens);
  }, []);

  useEffect(() => {
    service
      .getUser()
      .then(setUser)
      .catch(() => setUser(false));
  }, [tokens]);

  return (
    <Box
      sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {tokenToDelete && confirmDelete()}
      {buildCreator()}
      <DataGrid
        sx={{ flex: 1 }}
        loading={!tokens}
        columns={buildColumns()}
        rows={tokens || []}
      />
    </Box>
  );

  function buildCreator() {
    if (user === false || user === 'loading') {
      return (
        <Box
          sx={{
            mb: 2,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <LoadingButton
            loading={user === 'loading'}
            onClick={authorize}
            variant="contained"
            color="primary"
          >
            Add One
          </LoadingButton>
        </Box>
      );
    }
  }

  async function authorize() {
    setUser('loading');
    await service.authenticate();
  }

  function confirmDelete() {
    return (
      <ConfirmationDialog
        title="Delete Access Token"
        message={`Are you sure you want to delete the access token for ${tokenToDelete}`}
        handleClose={() => setTokenToDelete(null)}
        handleConfirm={() => deleteToken(tokenToDelete)}
      />
    );
  }

  async function deleteToken(username) {
    setTokenToDelete(null);

    await service.deleteAccessToken(username).then(() => {
      setTokens((current) => current.filter((c) => c.aaUser !== username));
    });
  }

  function buildColumns() {
    return [
      {
        field: 'aaUser',
        headerName: 'AA User',
        flex: 1,
      },
      {
        field: 'deereUser',
        headerName: 'Deere User',
        flex: 1,
      },
      {
        field: 'used',
        headerName: 'Times Used',
        align: 'left',
        headerAlign: 'left',
        flex: 0.5,
        type: 'number',
      },
      {
        field: 'expiresIn',
        headerName: 'Expires In',
        flex: 0.5,
      },
      {
        field: 'scopes',
        headerName: 'Scopes',
        flex: 1.5,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: '',
        getActions: ({ row }) => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => setTokenToDelete(row.aaUser)}
          />,
        ],
      },
    ];
  }
}
